export default __webpack_public_path__ + "static/media/googleAssistantLogo.f720c716.webp";